<script lang="ts">
  import {Icon} from '@components';
  import {useNewComponent} from '@/platform-redesign-components/FeatureFlag.svelte';

  enum Variant {
    none = 'none',
    vimeo = 'vimeo',
    upload = 'upload',
    youtube = 'youtube',
    primary = 'primary',
    subtract = 'subtract',
    secondary = 'secondary',
    primaryOutline = 'primaryOutline',
    negativeOutline = 'negativeOutline',
    previousNav = 'previousNav',
    nextNav = 'nextNav'
  }

  enum IconSize {
    small = 'w-3 h-3',
    normal = 'w-5 h-5'
  }

  export let text = '';
  export let icon = '';
  export let className = '';
  export let loading = false;
  export let disabled = false;
  export let iconDirection = 'ltr';
  export let variant: keyof typeof Variant = Variant.none;
  export let iconSize: keyof typeof IconSize = 'normal';
  export let buttonTitle = '';

  $: variantClass = getVariantClass();

  function getVariantClass() {
    switch (variant) {
      case Variant.primary:
        if (useNewComponent) {
          return 'disabled:bg-gray-200 disabled:text-gray-700 hover:bg-gray-200 hover:text-gray-700  bg-gray-700 text-gray-200';
        }
        return 'bg-neutral hover:bg-neutral-600 text-white disabled:bg-gray-400';
      case Variant.secondary:
        if (useNewComponent) {
          return 'bg-gray-200 hover:bg-gray-700 hover:text-gray-200 text-gray-700 disabled:bg-gray-700 disabled:text-gray-200';
        }
        return 'bg-gray-500 hover:bg-gray-700 text-white disabled:bg-gray-400';
      case Variant.subtract:
        if (useNewComponent) {
          return 'bg-[#F0456F] hover:bg-red-700 text-white disabled:bg-gray-400';
        }
        return 'bg-red-500 hover:bg-red-700 text-white disabled:bg-gray-400';
      case Variant.vimeo:
        return 'border-2 border-vimeo hover:bg-vimeo text-vimeo hover:text-white';
      case Variant.youtube:
        return 'border-2 bg-red-500 hover:bg-red-600 text-white';
      case Variant.primaryOutline:
        if (useNewComponent) {
          return 'border border-gray-700 bg-white text-gray-700 hover:bg-gray-700 hover:text-white disabled:bg-gray-700 disabled:text-gray-200';
        }
        return 'border-2 border-neutral hover:bg-neutral text-neutral hover:text-white disabled:border-gray-400 disabled:text-gray-400 disabled:hover:bg-gray-400 disabled:hover:text-white';
      case Variant.negativeOutline:
        if (useNewComponent) {
          return 'border border-gray-300 text-gray-700 hover:bg-gray-700  hover:text-white disabled:border-gray-400 disabled:text-gray-400 disabled:hover:bg-gray-400 disabled:hover:text-white';
        }
        return 'border-2 border-red-400 hover:bg-red-400 text-red-400 hover:text-white disabled:border-gray-400 disabled:text-gray-400 disabled:hover:bg-gray-400 disabled:hover:text-white';
      case Variant.none:
        return '';
      case Variant.upload:
        return 'border-2 border-primary px-2 hover:bg-primary text-primary hover:text-white disabled:bg-gray-400';
      case Variant.previousNav:
        if (useNewComponent) {
          return 'border border-[#f0456f] bg-white text-[#f0456f] hover:bg-[#f0456f] hover:text-white disabled:bg-[#f0456f] disabled:text-gray-200';
        }
        return 'border-2 border-neutral hover:bg-neutral text-neutral hover:text-white disabled:border-gray-400 disabled:text-gray-400 disabled:hover:bg-gray-400 disabled:hover:text-white';
      case Variant.nextNav:
        if (useNewComponent) {
          return 'bg-[#F0456F] hover:bg-red-700 text-white disabled:bg-gray-400';
        }
        return 'border-2 border-neutral hover:bg-neutral text-neutral hover:text-white disabled:border-gray-400 disabled:text-gray-400 disabled:hover:bg-gray-400 disabled:hover:text-white';
      default:
        return 'bg-primary hover:bg-primary-600 text-white disabled:bg-gray-400';
    }
  }
</script>

<button
  on:click
  on:mouseenter
  on:mouseleave
  class:!px-2={iconSize === 'small'}
  class:!px-3={iconSize === 'normal'}
  class="flex items-center justify-center rounded py-2 transition-all duration-150 ease-linear {variantClass} {className} disabled:cursor-not-allowed"
  {disabled}
  title={buttonTitle}
>
  <slot />
  {#if loading}
    <div class="order-first flex items-center">
      <Icon name="Loading" className={IconSize['normal']} />
    </div>
  {/if}

  {#if !!icon}
    <div
      class="flex items-center"
      class:order-last={iconDirection === 'rtl'}
      class:order-first={iconDirection === 'ltr'}
    >
      <Icon name={icon} className={IconSize[iconSize]} />
    </div>
  {/if}
  {text}
</button>

<style lang="postcss">
  .old_button {
    @apply text-sm font-bold;
    @apply cursor-pointer;
    @apply items-center justify-center gap-2;
    @apply transition-all duration-150 ease-linear;
  }
</style>
